import {ShouldSkipLazyLoadFn} from 'app/interface';
import {parseHashUrl} from 'app/utils/urlStateElements/parseHashUrl';

export const shouldSkipLazyLoad: ShouldSkipLazyLoadFn = ({config}) => {
    if (!config) {
        throw new Error('Config is missing!');
    }

    const urlState = parseHashUrl(window.location.hash.substring(1));
    return urlState[config.cId] ? 'LOAD_EAGER' : 'LOAD_LAZY';
};
